import styled from 'styled-components';

export const SectionContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 500px;
  padding: 20px 30px 30px 30px;
  text-align: center;
  width: 100%;
  z-index: 2;
  @media (min-width: 800px), (min-device-width: 768px) {
    align-items: flex-start;
    margin-bottom: 80px;
    max-width: 430px;
    padding: 20px;
    text-align: left;
    width: 500px;
  }
  @media (min-width: 1200px) {
    padding-left: 60px;
  }
`;

export const BgVideo = styled.video`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center center;
  position: absolute;
`;
